import Vue from 'vue';
import VueResource from "vue-resource";
import config from '@/config';

Vue.use(VueResource);

config.setapikey();

export const corporateService = {
    auth,
    reenviarAcesso,
    enviarConvenio,
    validarCodigo
}

function auth(code) {
    let url = config.api + `/v1/corporate/auth`;

    let obj = {
        code
    };

    var ret = new Promise(
        function (resolve, reject) {
            Vue.http.post(url, obj, { emulateJSON: true }).then(res => {
                resolve(res.body);
            }, err => {
                reject({
                    error: true,
                    msg: err
                });
            });
        }
    );
    return ret;
}

function validarCodigo(code) {
    let url = config.api + `/v1/corporate/checkcode`;
    let obj = {
        code
    };

    const ret = new Promise((resolve, reject) => {
            Vue.http.post(url, obj, { emulateJSON: true }).then(res => {
                console.log('validarCodigo: ');
                console.log(res.body);
                resolve(res.body);
            }, err => {
                reject({
                    error: true,
                    msg: err
                });
            });
        }
    );
    return ret;
}
function reenviarAcesso(form) {
    let url = config.api + `/v1/corporate/reenviaracesso`;

    let obj = {
        nome: form.nome_n,
        email: form.email_e,
        nome_empresa: form.company_c,
        ddd: form.ddd_d,
        celular: form.phone_p,
    };

    var ret = new Promise(
        function (resolve, reject) {
            Vue.http.post(url, obj, { emulateJSON: true }).then(res => {
                resolve(res.body);
            }, err => {
                reject({
                    error: true,
                    msg: err
                });
            });
        }
    );
    return ret;
}

function enviarConvenio(form) {
    let url = config.api + `/v1/corporate/enviarconvenio`;

    let obj = {
        nome: form.requester,
        cargo: form.office,
        nome_empresa: form.company,
        email: form.email,
        ddd: form.ddd,
        celular: form.phone,
        numero_colaboradores: form.contributors,
        cep: form.cep,
        endereco: form.address,
        cidade: form.city,
        estado: form.city_state,
        filiais_em: form.branches,
        como_soube_programa: form.question1,
    };

    var ret = new Promise(
        function (resolve, reject) {
            Vue.http.post(url, obj, { emulateJSON: true }).then(res => {
                resolve(res.body);
            }, err => {
                reject({
                    error: true,
                    msg: err
                });
            });
        }
    );
    return ret;
}